import { SearchOutlined } from '@ant-design/icons';
import { Breadcrumb, Col, Input, message, Popconfirm, Row, Space, Table, Tooltip } from 'antd';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { ReactComponent as ArchiveRestore } from '../../Images/ArchiveRestore.svg';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { ReactComponent as FilterIcon } from '../../Images/FilterIcon.svg';
import { fetchArchivedNalcoRateList, unArchiveNalcoRate } from '../../slices/nalco-rate';

function ArchiveNalco() {

    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [search, setSearch] = useState('');
    const [page, setPage] = useState(1);
    const [pagesize, setPageSize] = useState(10);

    const dispatch = useDispatch();
    const { data = [], totalRecord = 0, status } = useSelector(state => state.nalcoRate || {});
    useEffect(() => {
        dispatch(fetchArchivedNalcoRateList({ page, pagesize, ...(search && { search: search }) }),
        );
    }, [dispatch, page, pagesize, search]);

    const rowSelection = {
        selectedRowKeys,
        onChange: selectedKeys => {
            setSelectedRowKeys(selectedKeys);
        },
    };

    const handleSearch = e => {
        setSearch(e.target.value);
        setPage(1); // Reset to the first page when searching
    };

    const resetFilter = () => {
        setSearch('');
        setPage(1);
    };

    const handlePageChange = newPage => {
        setPage(newPage);
    };
    const handleTableChange = async (pagination, filters, sorter, ordering) => {
        setPageSize(pagination.pageSize);
    };
    const dataSource = data.map((item, index) => ({
        ...item,
        key: item.id || index,
        SrNo: (page - 1) * pagesize + index + 1, // Calculate Sr. No. based on page and limit
    }));

    const handleRestore = id => {
        if (!id) {
            message.error('Missing ID for deletion!');
            return;
        }

        dispatch(unArchiveNalcoRate(id))
            .unwrap()
            .then(() => {
                message.success('Nalco Rate Unarchived Successfully!');
            })
            .catch(error => {
                if (typeof error === 'object' && error !== null) {
                    const messages = [];
                    for (const key in error) {
                        if (Array.isArray(error[key])) {
                            messages.push(`${key}: ${error[key].join(', ')}`);
                        }
                    }

                    if (messages.length > 0) {
                        message.error(messages.join('; '));
                    } else {
                        message.error('An unknown error occurred.');
                    }
                } else if (typeof error === 'string') {
                    message.error(error); // Handle string error
                } else if (error instanceof Error) {
                    message.error(error.message); // Handle Error object
                } else {
                    message.error('An unknown error occurred.');
                }
            });
    };


    const columns = [
        {
            title: 'Sr. No.',
            dataIndex: 'SrNo',
            key: 'SrNo',
            width: 100,
            sorter: true,
        },
        {
            title: 'Date',
            dataIndex: 'date',
            key: 'date',
            sorter: true,
        },
        {
            title: 'Ignot Grade',
            dataIndex: 'ignot_grade',
            key: 'ignot_grade',
            sorter: true,
        },

        {
            title: 'Rate',
            dataIndex: 'rate',
            key: 'rate',
            sorter: true,
        },
        {
            title: 'Rate/ MT',
            dataIndex: 'rate_per_mt',
            key: 'rate_per_mt',
            sorter: true,
        },
        {
            title: 'Difference',
            dataIndex: 'difference',
            key: 'difference',
            sorter: true,
        },
        {
            title: 'Archive At',
            dataIndex: 'updated_at',
            key: 'updated_at',
            sorter: true,
            render: (record) => {
                return (
                    <span>{record ? dayjs(record).format('DD-MM-YYYY HH:mm') : 'N/A'} </span>
                )
            }
        },
        {
            title: 'Archive By',
            dataIndex: 'updated_by',
            key: 'updated_by',
            sorter: true,
            render: (record) => {
                return (
                    <span>{record ? `${record.first_name} ${record.last_name}` : 'N/A'} </span>
                )
            }
        },
        {
            title: 'Action',
            dataIndex: '',
            key: 'action',
            render: (text, record) => (
                <Space>
                    <Link>
                        <Tooltip title="Restore">
                            <Popconfirm
                                title="Are you sure you want to Unarchive this record?"
                                onConfirm={() => handleRestore(record.id)} // Trigger delete on confirmation
                                onCancel={() => message.info('Action cancelled')} // Optional cancel action
                                okText="Yes"
                                cancelText="No"
                            >
                                <ArchiveRestore className="ArchiverestorImg" />
                            </Popconfirm>
                        </Tooltip>
                    </Link>
                </Space>
            ),
        },
    ];
    return (
        <>
            <div className='sticyaction'>
                <Row className="pagenamerow" justify="space-between" align="middle">
                    <Col>
                        <h2>Archived Nalco Rate</h2>
                        <div className="bredcrumbwrp">
                            <Link to="/nalco" className="back">
                                <Back /> BACK
                            </Link>
                            <Breadcrumb
                                items={[
                                    { title: <Link to="/nalco">Nalco Rate</Link> },
                                    { title: 'Archived Nalco Rate' }
                                ]}
                            />
                        </div>
                    </Col>
                    <Col>
                        <Space size="middle">
                            <Input
                                placeholder="Search"
                                className='searchbox'
                                prefix={<SearchOutlined />}
                                value={search}
                                onChange={handleSearch}
                                style={{ width: '100%' }}
                            />
                            <Link className='iconlink'>
                                <Tooltip title="Filter">
                                    <FilterIcon />
                                </Tooltip>
                            </Link>
                        </Space>
                    </Col>

                </Row>
            </div>
            <div style={{ position: 'sticky', top: 0, zIndex: 1000, background: '#fff' }}>

                <Table
                    dataSource={dataSource}
                    columns={columns}
                    loading={status === 'loading'}
                    pagination={{
                        current: page, // Update the current page based on state
                        pageSize: pagesize,
                        total: totalRecord,
                        showSizeChanger: true,
                        onChange: handlePageChange, // Update page when changed
                    }}
                    onChange={handleTableChange}
                    style={{ marginTop: '20px' }}
                    scroll={{
                        x: 880, // Horizontal Scroll
                        y: 400,  // Vertical Scroll with Fixed Header
                    }}

                />
            </div>

        </>
    )
}

export default ArchiveNalco;
